export function createUploadScheduler(maxConcurrency = 4) {
  const limit = Math.max(1, Number(maxConcurrency) || 1);
  const queue = [];
  let activeCount = 0;

  function execute(entry) {
    activeCount += 1;
    Promise.resolve()
      .then(entry.work)
      .then(entry.resolve, entry.reject)
      .finally(() => {
        activeCount -= 1;
        drain();
      });
  }

  function drain() {
    while (activeCount < limit && queue.length) {
      const entry = queue.shift();
      execute(entry);
    }
  }

  return {
    run(work) {
      if (typeof work !== "function") {
        return Promise.reject(
          new Error("Scheduled upload work must be a function.")
        );
      }
      return new Promise((resolve, reject) => {
        queue.push({ work, resolve, reject });
        drain();
      });
    },
    getState() {
      return { activeCount, queuedCount: queue.length, maxConcurrency: limit };
    }
  };
}

export async function runUploadBatch(items, worker, maxConcurrency = 4) {
  if (typeof worker !== "function") {
    throw new Error("An upload batch worker is required.");
  }

  const batch = Array.isArray(items) ? items : [];
  if (!batch.length) return [];

  const limit = Math.max(1, Number(maxConcurrency) || 1);
  const results = new Array(batch.length);
  let nextIndex = 0;

  async function runNext() {
    while (nextIndex < batch.length) {
      const index = nextIndex;
      nextIndex += 1;
      results[index] = await worker(batch[index], index);
    }
  }

  await Promise.all(
    Array.from({ length: Math.min(limit, batch.length) }, () => runNext())
  );
  return results;
}
